import { render, staticRenderFns } from "./themegj-list.vue?vue&type=template&id=06fa7dd4&"
import script from "./themegj-list.vue?vue&type=script&lang=js&"
export * from "./themegj-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports